export default __webpack_public_path__ + "static/giotto-3-46d3bcec08ddc8b475d83826c8e6a810.jpg";